import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import type { TDeleteContractorPaymentDeductionRequest } from "./deleteContractorPaymentDeduction.schema";

export const deleteContractorPaymentDeduction = (axios: IAxiosInstance) => {
  return async (
    body: TDeleteContractorPaymentDeductionRequest
  ): Promise<void> => {
    const response = await axios.noRetry.delete<IApiResponse<null>>(
      "/api/contractor-payments/deductions",
      { data: body }
    );
    const data = response.data;

    if (data.success) {
      return;
    }

    throw new Error("Failed to remove deduction from contractor payment");
  };
};
